import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=25c5afd6&"
import script from "./ImageZoom.vue?vue&type=script&lang=js&"
export * from "./ImageZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports